module.exports = __webpack_public_path__ + "media/PAG66-06.4d7e8318.mp3";